export default "/images/vendor/flag-icon-css/flags/4x3/lv.svg?ff6176a6bfeba64d07169ecd7c2162a2";